const PinkSection = ({ children }) => {
	return (
		<section>
			<div className="wrap relative mx-auto bg-red bg-[url(/src/bgimages/step3bg.jpg)] bg-[length:100%_100%]">{children}</div>
		</section>
	)
}

export default PinkSection
